import { render } from "./ComponentTextMiningEntities.vue?vue&type=template&id=00b303fa&scoped=true"
import script from "./ComponentTextMiningEntities.vue?vue&type=script&lang=js"
export * from "./ComponentTextMiningEntities.vue?vue&type=script&lang=js"

import "./ComponentTextMiningEntities.vue?vue&type=style&index=0&id=00b303fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b303fa"]])

export default __exports__